import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import { visuallyHidden } from "@mui/utils";
import { Drawer } from "rsuite";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { Tooltip } from "@mui/material";
import Loader from "../Loader";
import axios from "axios";
import BaseUrl from "../BaseUrl";
// import noLeadsData from "../../src/Images/Business Plan-pana 1.svg"
import noLeadsData from "../../src/Images/ImageToStl.com_business+plan-pana+1.avif";
import {
  Button,
  FormControl,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import DrawerClassGoal from "./DrawerClassGoal";

const campaignHeadCells = [
  {
    id: "name",
    label: "Contact",
  },
  // {
  //   id: "calories",
  //   label: "Subscribed",
  // },
  {
    id: "fat",
    label: "Blocklisted",
  },
  {
    id: "carbs",
    label: "Emails",
  },
  {
    id: "first name",
    label: "First Name",
  },
  {
    id: "last name",
    label: "Last Name",
  },
  {
    id: "date added",
    label: "Date Added",
  },
  {
    id: "action",
    label: "Action",
  },
];

const GoalContacts = () => {
  const userDetails = JSON.parse(localStorage.getItem("MailSenderuserDetails"));
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [leadsData, setLeadsData] = useState([]);
  const [toEmailArray, setToEmailArray] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [campaignId, setCampaignId] = useState(null);
  const [goalName, setGoalName] = useState(null);
  const location = useLocation();
  const history = useHistory();
  const [fromEmail, setFromEmail] = useState("");
  const [senderName, setSenderName] = useState("");
  const [senderMails, setSenderMails] = useState([]);
  const [tokenData, setTokenData] = useState("");
  const [refreshToken, setRefreshToken] = useState("");
  const [tokenExpiration, setTokenExpiration] = useState("");
  const [fromEmailExtraData, setFromEmailExtraData] = useState({});
  const [subject, setSubject] = useState("");
  const [variableArray, setVariableArray] = useState([
    "First Name",
    "Last Name",
    "Email",
    "Phone Number",
  ]);
  const [emailBody, setEmailBody] = useState("");
  const handleSelectAllClick = (event) => {
    // if (event.target.checked) {
    //   const newSelected = leadsData.map((n) => n._id);
    //   setSelected(newSelected);
    // } else {
    //   setSelected([]);
    // }
    if (event.target.checked) {
      setSelected([...leadsData]);
    } else {
      setSelected([]);
    }
  };

  const handleClick = (event, id) => {
    // Check if the clicked element is the checkbox
    // if (event.target.type === 'checkbox') {
    //   const selectedIndex = selected.indexOf(id);
    //   let newSelected = [];
    //   if (selectedIndex === -1) {
    //     newSelected = newSelected.concat(selected, id);
    //   } else if (selectedIndex === 0) {
    //     newSelected = newSelected.concat(selected.slice(1));
    //   } else if (selectedIndex === selected.length - 1) {
    //     newSelected = newSelected.concat(selected.slice(0, -1));
    //   } else if (selectedIndex > 0) {
    //     newSelected = newSelected.concat(
    //       selected.slice(0, selectedIndex),
    //       selected.slice(selectedIndex + 1),
    //     );
    //   }

    //   setSelected(newSelected);
    // }
    // if (event.target.type === 'checkbox') {
    //   const isSelected = selected.some((selectedRow) => selectedRow.id === id);

    //   let newSelected = [];

    //   if (isSelected) {
    //     newSelected = selected.filter((selectedRow) => selectedRow.id !== id);
    //   } else {
    //     newSelected = [...selected, id];
    //   }

    //   setSelected(newSelected);
    // }
    if (event.target.type === "checkbox") {
      const isSelected = selected.some((selectedRow) => selectedRow.id === id);

      let newSelected = [];

      if (isSelected) {
        newSelected = selected.filter((selectedRow) => selectedRow.id !== id);
      } else {
        newSelected = [
          ...selected,
          { id, data: leadsData.find((row) => row.id === id) },
        ];
      }

      setSelected(newSelected);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const enhanceTableHeader = () => {
    return (
      <TableHead>
        <TableRow sx={{ backgroundColor: "#FAFAFA" }}>
          {leadsData.length > 0 && (
            <TableCell padding="checkbox">
              <Checkbox
                sx={{
                  color: "#1C485F",
                  borderWidth: "1px",
                  "&.Mui-checked": {
                    color: "#1C485F",
                  },
                }}
                disableRipple
                disableTouchRipple
                indeterminate={selected.length > 0}
                checked={selected.length > 0}
                onChange={handleSelectAllClick}
                inputProps={{
                  "aria-label": "select all rows",
                }}
              />
            </TableCell>
          )}
          {campaignHeadCells.map((cell) => (
            <TableCell
              key={cell.id}
              align={cell.id === "name" ? "left" : "center"}
              style={{ fontWeight: "bold" }}
            >
              {cell.label}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  };

  const handleFromEmail = (event) => {
    setFromEmail(event.target.value.FromEmail);
    setSenderName(event.target.value);
  };

  // const isSelected = (id) => selected.indexOf(id) !== -1;
  const isSelected = (id) =>
    selected.some((selectedRow) => selectedRow.id === id);

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - leadsData.length) : 0;

  useEffect(() => {
    if (location.pathname.length > 12) {
      setIsLoading(true);
      axios
        .get(
          `${
            BaseUrl.baseurl
          }/email-marketing/automation/get-campaign-goals-leads-details/${
            userDetails && userDetails.details._id
          }/${location.pathname.slice(12, location.pathname.length)}`,
          {
            headers: {
              Authorization: `Bearear ${userDetails && userDetails.token}`,
            },
          }
        )
        .then((response) => {
          if (response.data.status) {
            console.log(
              "otken",
              response.data.details?.FromEmilDetails
            );
            setTokenData(
              response.data.details?.FromEmilDetails[0]?.AccessToken
            );
            setTokenExpiration(
              response.data.details?.FromEmilDetails[0]?.TokenExpiryDate
            );

            setRefreshToken(
              response.data.details?.FromEmilDetails[0]?.RefreshToken
            );
            setSenderMails(response.data.details?.FromEmilDetails);
            setIsLoading(false);
            setGoalName(response.data.details?.GoalDetails?.Name);
            setCampaignId(response.data.details?.Campaign?._id);
            setLeadsData(response.data.details?.Details);
          } else {
            setSenderMails([]);
            setIsLoading(false);
            setGoalName("");
            setCampaignId(null);
            setLeadsData([]);
            if (response.data.tokenExpire) {
              localStorage.removeItem("MailSenderuserDetails");
              window.location.reload();
            }
          }
        })
        .catch((err) => console.log("Error"));
    }
  }, [location.pathname.slice(12, location.pathname.length)]);

  const timezoneArr = [
    {
      id: 1,
      email: "John@example.com",
    },
    {
      id: 2,
      email: "John@example2.com",
    },
    {
      id: 3,
      email: "John@example3.com",
    },
  ];

  const handleSendEmails = () => {
    return (
      <Drawer size="lg" open={openDrawer} onClose={() => setOpenDrawer(false)}>
        <div style={{ height: "100%",display:'flex',flexDirection:'column',border:'1px solid #DDD' }}>
          <div
            style={{
              borderBottom: "1px solid #DDD",
              padding: "12px",
              flexShrink:0
            }}
          >
            <p
              style={{
                fontFamily: "Source Sans 3",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: 700,
                color: "#4B4B4B",
              }}
            >
              Email
            </p>
          </div>
          <div style={{display:'flex',flexDirection:'column',margin:'10px',border:'1px solid #DDD',flexGrow:1,borderRadius:5,overflow:'hidden',padding:'12px'}}>
          <div
            style={{
              // display: "flex",
              // alignItems: "flex-start",
              // gap: "5px",
              // alignSelf: "stretch",
              flexShrink:0
            }}
          >
            <div
              style={{
                padding: "4px 8px",
                border: "1px solid #1C485F",
                borderRadius: "4px",
                display: "flex",
                alignItems: "center",
                gap: "4px",
                width: "100%",
              }}
            >
              <p
                style={{
                  fontFamily: "Source Sans 3",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: 400,
                  color: "#4B4B4B",
                  marginTop: "-2px",
                }}
              >
                From:
              </p>
              <FormControl size="medium" sx={{ width: "100%" }}>
                <Select
                  displayEmpty
                  variant="standard"
                  value={fromEmail}
                  disableUnderline
                  onChange={handleFromEmail}
                  sx={{
                    outline: "none",
                    backgroundColor: "#FFF",
                    padding: "2px",
                    borderRadius: "4px",
                    fontFamily: "Source Sans 3",
                    fontSize: "12px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    color: "#4B4B4B",
                  }}
                  renderValue={(selected) => {
                    if (selected.length === 0) {
                      return (
                        <p
                          style={{
                            fontStyle: "normal",
                            fontSize: "14px",
                            color: "#888888",
                            paddingLeft: "6px",
                          }}
                        >
                          Choose your email
                        </p>
                      );
                    }
                    return selected;
                  }}
                  inputProps={{ "aria-label": "Without label" }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 160,
                      },
                    },
                  }}
                >
                  {senderMails.length !== 0 &&
                    senderMails.map((name, index) => (
                      <MenuItem
                        disableRipple
                        disableTouchRipple
                        key={index}
                        value={name}
                        sx={{
                          borderBottom:
                            senderMails.length !== index + 1 &&
                            "1px solid #DDD",
                          fontFamily: "Source Sans 3",
                          fontSize: "14px",
                          fontWeight: 400,
                          fontStyle: "normal",
                          color: "#838383",
                          padding: "6px",
                        }}
                      >
                        {name.FromEmail}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </div>
          </div>
          <div style={{flexGrow:1}}>
          <DrawerClassGoal
            subject={subject}
            setSubject={setSubject}
            setEmailBody={setEmailBody}
            AccessToken={tokenData}
            refreshToken={refreshToken}
            tokenExpiration={tokenExpiration}
            campaginId={campaignId}
            emailBody={emailBody}
            setOpenDrawer={setOpenDrawer}
            variableArray={variableArray}
            senderName={senderName}
            toEmailArray={selected}
          />
          </div>
          </div>
        </div>
      </Drawer>
    );
  };
  function formatDateString(inputString) {
    const date = new Date(inputString);
    const formattedDate = new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).format(date);

    return formattedDate;
  }

  return (
    <div
      style={{
        height: "100%",
        overflow: "auto",
      }}
    >
      <Box sx={{ width: "100%" }}>
        <Paper
          sx={{ width: "100%", border: "1px solid #DDD", boxShadow: "none" }}
        >
          {selected.length === 0 ? (
            <Box sx={{ padding: "6px 16px", borderBottom: "1px solid #DDD" }}>
              {goalName !== null && goalName !== undefined && (
                <Button
                  disableRipple
                  disableElevation
                  sx={{
                    cursor: "default",
                    outline: "none !important",
                    borderBottom: "2px solid #1C485F",
                    borderRadius: 0,
                    color: "#1C485F",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    textTransform: "none",
                    "&:hover": {
                      backgroundColor: "transparent",
                    },
                  }}
                >
                  <svg
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      history.push(`/Goals/${campaignId}`);
                    }}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.57 5.92969L3.5 11.9997L9.57 18.0697"
                      stroke="#1C485F"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M20.5019 12H3.67188"
                      stroke="#1C485F"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <Typography
                    style={{
                      color: "#1C485F",
                      fontSize: "15px",
                      fontWeight: 700,
                      fontFamily: "Source Sans 3",
                    }}
                    component="h2"
                  >
                    {goalName}
                  </Typography>
                </Button>
              )}
            </Box>
          ) : (
            <Box
              sx={{
                borderBottom: "1px solid #DDD",
                padding: "6px 16px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                backgroundColor: "#FFF",
                borderTopLeftRadius: "6px",
                borderTopRightRadius: "6px",
              }}
            >
              <p
                style={{
                  fontFamily: "Source Sans 3",
                  fontSize: "16px",
                  fontStyle: "normal",
                  fontWeight: 700,
                  color: "#4B4B4B",
                }}
              >
                {selected.length} Contacts selected
              </p>
              <button
                onClick={() => {
                  setSubject("");
                  setEmailBody("");
                  setOpenDrawer(true);
                }}
                style={{
                  fontSize: "14px",
                  borderRadius: "4px",
                  outline: "none",
                  color: "#FFF",
                  padding: "9px 16px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "8px",
                  backgroundColor: "#FF3301",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 21 20"
                  fill="none"
                >
                  <path
                    d="M14.7656 17.0837H6.43229C3.93229 17.0837 2.26562 15.8337 2.26562 12.917V7.08366C2.26562 4.16699 3.93229 2.91699 6.43229 2.91699H14.7656C17.2656 2.91699 18.9323 4.16699 18.9323 7.08366V12.917C18.9323 15.8337 17.2656 17.0837 14.7656 17.0837Z"
                    stroke="#FFF"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M14.7669 7.5L12.1586 9.58333C11.3003 10.2667 9.89192 10.2667 9.03359 9.58333L6.43359 7.5"
                    stroke="#FFF"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                Send email
              </button>
            </Box>
          )}
          <TableContainer>
            <Table
              sx={{ minWidth: 750 }}
              aria-labelledby="tableTitle"
              size="medium"
            >
              {isLoading ? (
                <TableBody>
                  <TableRow>
                    <TableCell
                      colSpan={campaignHeadCells.length}
                      align="center"
                      sx={{ borderBottom: "0px" }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: "8px",
                          padding: "130px 0px",
                        }}
                      >
                        <Loader />
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : leadsData.length > 0 ? (
                <>
                  {enhanceTableHeader()}
                  <TableBody>
                    {leadsData
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row, index) => {
                        const isItemSelected = isSelected(row.id);
                        const labelId = `enhanced-table-checkbox-${index}`;

                        return (
                          <TableRow
                            onClick={(event) => handleClick(event, row.id)}
                            role="checkbox"
                            tabIndex={-1}
                            key={row.id}
                            sx={{
                              backgroundColor:
                                index % 2 !== 0 ? "#FAFAFA" : "white",
                            }}
                          >
                            <TableCell padding="checkbox">
                              <Checkbox
                                disableRipple
                                disableTouchRipple
                                checked={isItemSelected}
                                inputProps={{
                                  "aria-labelledby": labelId,
                                }}
                                sx={{
                                  color: "#1C485F",
                                  borderWidth: "1px",
                                  "&.Mui-checked": {
                                    color: "#1C485F",
                                  },
                                }}
                              />
                            </TableCell>
                            <TableCell component="th" id={labelId} scope="row">
                              {row.Contact ? row.Contact : "--"}
                            </TableCell>
                            {/* <TableCell align="center">{row.subscribed ? row.subscribed : '--'}</TableCell> */}
                            <TableCell align="center">
                              {row.Blocked ? "Yes" : "No"}
                            </TableCell>
                            <TableCell align="center">{row.Email}</TableCell>
                            <TableCell align="center">
                              {row.FirstName ? row.FirstName : "--"}
                            </TableCell>
                            <TableCell align="center">
                              {row.LastName ? row.LastName : "--"}
                            </TableCell>
                            <TableCell align="center">
                              {/* {formatDateString(row.Date)} */} --
                            </TableCell>
                            <TableCell align="right">
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <button
                                  onClick={() => {
                                    setToEmailArray([row]);
                                    setSelected([row]);
                                    setSubject("");
                                    setEmailBody("");
                                    setOpenDrawer(true);
                                  }}
                                  style={{
                                    fontSize: "10px",
                                    borderRadius: "4px",
                                    outline: "none",
                                    border: `1.5px solid #1C485F`,
                                    color: "#1C485F",
                                    padding: "7px 10px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "8px",
                                    backgroundColor: "transparent",
                                  }}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 21 20"
                                    fill="none"
                                  >
                                    <path
                                      d="M14.7656 17.0837H6.43229C3.93229 17.0837 2.26562 15.8337 2.26562 12.917V7.08366C2.26562 4.16699 3.93229 2.91699 6.43229 2.91699H14.7656C17.2656 2.91699 18.9323 4.16699 18.9323 7.08366V12.917C18.9323 15.8337 17.2656 17.0837 14.7656 17.0837Z"
                                      stroke="#1C485F"
                                      stroke-width="1.5"
                                      stroke-miterlimit="10"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M14.7669 7.5L12.1586 9.58333C11.3003 10.2667 9.89192 10.2667 9.03359 9.58333L6.43359 7.5"
                                      stroke="#1C485F"
                                      stroke-width="1.5"
                                      stroke-miterlimit="10"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                  Send email
                                </button>
                              </Box>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    {emptyRows > 0 && (
                      <TableRow
                        style={{
                          height: 53 * emptyRows,
                        }}
                      >
                        <TableCell colSpan={10} />
                      </TableRow>
                    )}
                  </TableBody>
                </>
              ) : (
                // empty view body nothing found content here...
                <TableBody>
                  <TableRow>
                    <TableCell
                      colSpan={campaignHeadCells.length}
                      align="center"
                      sx={{ borderBottom: "0px" }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <img
                          loading="lazy"
                          src={noLeadsData}
                          alt="Nothing found"
                          style={{ height: "250px" }}
                        />
                        <p
                          style={{
                            fontFamily: "Source Sans 3",
                            fontSize: "20px",
                            fontStyle: "normal",
                            fontWeight: 700,
                            color: "#393939",
                          }}
                        >
                          No data found
                        </p>
                        <p
                          style={{
                            fontFamily: "Source Sans 3",
                            fontSize: "14px",
                            fontStyle: "normal",
                            fontWeight: 400,
                            color: "#868686",
                            marginTop: "0px",
                          }}
                        >
                          Oops! You don’t have any leads yet!
                        </p>
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
          {isLoading
            ? null
            : leadsData.length > 0 && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                  }}
                >
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={leadsData.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </div>
              )}
          {openDrawer && handleSendEmails()}
        </Paper>
      </Box>
    </div>
  );
};

export default GoalContacts;
